var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card',[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col"},[_c('p',[_vm._v("rischio: "+_vm._s(_vm.rischio))])])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }